<template>
  <div class="advance_wrapper" :class="{ 'filter-loading': filterLoading }">
    <van-nav-bar title="预收款" @click-left="$utils.goBack()">
      <template #left>
        <span class="icon-left"></span>
      </template>
    </van-nav-bar>

    <div class="advance_list">
      <div class="advance_item">
        <div class="item_title">车场名称</div>
        <div class="item_content">{{ orderObj.parkingName }}</div>
      </div>

      <div class="advance_item">
        <div class="item_title">车位号</div>
        <div class="item_content">{{ orderObj.parkingNumber }}</div>
      </div>

      <div class="advance_item">
        <div class="item_title">车牌号</div>
        <div class="item_content">{{ orderObj.plateNumber }}</div>
      </div>

      <div class="advance_item">
        <div class="item_title">入场时间</div>
        <div class="item_content">{{ orderObj.enterTime }}</div>
      </div>

      <div class="advance_item" @click="showPicker = true">
        <div class="item_title">预收金额</div>
        <div class="item_content">
          {{ prePayAmount ? `${prePayAmount}元` : "请选择" }}
        </div>
        <div class="item_icon">
          <span class="icon-right"></span>
        </div>
      </div>

      <!-- <div class="advance_item" v-show="prePayAmount">
        <div class="item_title">预收金额</div>
        <div class="item_content">{{ orderObj.orderAmount }}</div>
      </div> -->
    </div>

    <van-popup v-model="showPicker" round position="bottom">
      <div class="advance_picker">
        <van-picker
          show-toolbar
          title="请选择金额"
          :columns="columns"
          :default-index="defaultIndex"
          :item-height="50"
          :swipe-duration="500"
          @cancel="onCancel"
          @confirm="onConfirm"
        />
      </div>
    </van-popup>

    <div
      class="advance_pay btn"
      :class="{ disabled: !prePayAmount }"
      @click="setPrePayAmount()"
    >
      支付
    </div>

    <!-- 二维码页面 -->
    <transition tag="div" name="pop">
      <qr-code
        v-show="showQRCode"
        @closeQRCode="closeQRCode"
        @failCallback="failCallback"
        @onPay="payFunc"
        @successCallback="successCallback"
        :showQRCode="showQRCode"
        :orderParkingId="orderObj.id"
        :isFirst="isFirst"
        :qrCodeInterFace="qrCodeInterFace"
      ></qr-code>
    </transition>

    <div v-if="isPaying" class="paying_mask">
      <!-- 支付中展示页面 -->
      <div class="payLoading">
        <span>支付中</span>
        <span class="point point1_animation"></span>
        <span class="point point2_animation"></span>
        <span class="point point3_animation"></span>
      </div>
    </div>
  </div>
</template>

<script>
import scanPayMixin from "../../utils/scanPayMixin";

import {
  ORDER_PARKING_FIND_ORDER_PARKING_BY_ID,
  ORDER_PARKING_GET_PREPAY_AMOUNT_LIST,
  ORDER_PARKING_QRCODE,
  ORDER_PARKING_SCANCODE_PAY,
  ORDER_PARKING_SET_PREPAY_AMOUNT
} from "../../config/config";
import qrCode from "../../components/QRCode";
import { Toast } from "vant";
import JsBridge from "../../utils/JSBridge/JsBridge";

export default {
  mixins: [scanPayMixin],

  components: {
    qrCode
  },

  data: () => ({
    columns: [],
    prePayAmount: null,
    showPicker: false,
    orderObj: {},
    orderParkingId: "",
    parkingSpaceId: "",
    defaultIndex: 0,
    isFirst: false,
    showQRCode: false,
    qrCodeInterFace: "",
    isRecovery: false,
    filterLoading: false
  }),

  methods: {
    setPrePayAmount() {
      if (this.prePayAmount) {
        this.orderAmount = this.prePayAmount;

        this.$request(
          ORDER_PARKING_SET_PREPAY_AMOUNT,
          {
            prePayAmount: this.prePayAmount,
            orderParkingId: this.orderParkingId
          },
          res => {
            if (this.$condition.isRequestSuccess(res)) {
              this.onShowQRCode();
            }
          }
        );
      } else {
        Toast.fail("请选择金额");
      }
    },

    onShowQRCode() {
      this.qrCodeInterFace = ORDER_PARKING_QRCODE;
      this.showQRCode = true;
    },

    getPrepayAmountList() {
      this.$request(
        ORDER_PARKING_GET_PREPAY_AMOUNT_LIST,
        {
          parkingSpaceId: this.parkingSpaceId
        },
        res => {
          if (this.$condition.isRequestSuccess(res)) {
            let data = res["data"];

            this.columns = [];

            data.forEach((item, i) => {
              this.columns.push({
                ...item,
                text: `${item.preAmount}元`
              });

              if (item.isDefault) {
                this.defaultIndex = i;
                this.prePayAmount = item.preAmount;
              }
            });
          }
        }
      );
    },
    onConfirm(value) {
      this.prePayAmount = value.preAmount;

      this.showPicker = false;
    },
    onCancel() {
      this.showPicker = false;
    },
    payFunc(id) {
      this.isFirst = false;
      this.onPay(id);
    },

    closeQRCode() {
      this.isFirst = false;

      this.showQRCode = false;
    },

    //二维码失败回调
    failCallback() {
      this.$router.replace({
        name: "Result",
        params: {
          orderStatus: this.orderObj.orderStatus,
          oid: this.orderParkingId,
          orderAmount: this.prePayAmount,
          isRecovery: this.isRecovery
        }
      });
    },

    successCallback() {
      this.$router.replace({
        name: "Result",
        params: {
          orderStatus: 20,
          oid: this.orderParkingId,
          orderAmount: this.prePayAmount,
          isRecovery: this.isRecovery
        }
      });
    }
  },

  created() {
    this.$utils.changeStatusBarStyle("black");
    this.filterLoading = true;
    this.$utils.showLoading();

    this.orderParkingId = this.$route.query.orderParkingId;
    this.parkingSpaceId = this.$route.query.parkingSpaceId;

    let url = ORDER_PARKING_FIND_ORDER_PARKING_BY_ID;

    this.scanCodeInterface = ORDER_PARKING_SCANCODE_PAY;

    this.$request(
      url,
      {
        orderParkingId: this.orderParkingId
      },
      res => {
        this.$utils.closeLoading();

        let data = res["data"];

        for (let k in data) {
          //赋值，set方法引起页面刷新
          this.$set(this.orderObj, k, data[k]);
        }
        this.filterLoading = false;
        this.getPrepayAmountList();
      }
    );
  },

  mounted() {
    JsBridge.registerHandler("showQRCode", () => {
      this.onShowQRCode();
    });
  }
};
</script>

<style lang="less" scoped>
.pop-enter-to,
.pop-leave {
  transform: translateY(0);
  opacity: 1;
}
.pop-enter,
.pop-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
.pop-enter-active,
.pop-leave-active {
  transition: all 0.3s;
}

.advance_wrapper {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  padding-top: 26px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .icon-left {
    font-size: 24px;
    margin-right: 6px;
    color: #333;
  }

  /deep/ .van-nav-bar__title {
    font-size: 20px;
  }
}

.advance_list {
  width: 100%;
  padding: 0 14px;
  flex: 1;

  .advance_item {
    width: 100%;
    height: 66px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    color: #000;
    border-bottom: 1px solid rgba(7, 17, 27, 0.1);
    padding: 0 10px;

    .item_content {
      flex: 1;
      text-align: right;
      color: #333;
    }

    .item_icon {
      height: 100%;
      /*flex : 1 ;*/
      color: #333;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      /*font-weight : bold;*/
      color: #333;
    }
  }
}

.advance_picker /deep/ .van-picker {
  font-size: 18px;

  /deep/ .van-picker__cancel,
  /deep/ .van-picker__title,
  /deep/ .van-picker__confirm,
  /deep/ .van-picker-column__wrapper {
    font-size: 18px;
  }
}

.advance_pay {
  width: 80%;
  height: 44px;
  text-align: center;
  line-height: 44px;
  color: #fff;
  font-size: 20px;
  background-color: rgb(43, 95, 230);
  border-radius: 6px;
  margin: 20px auto;

  &.disabled {
    background-color: #ccc;
  }
}

.paying_mask {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 52;
  background-color: rgba(7, 17, 27, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;

  .payLoading {
    margin: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 26px;
    color: skyblue;

    .point {
      display: block;
      width: 10px;
      height: 10px;
      // border : 1PX solid #333 ;
      border-radius: 50%;
      margin-left: 10px;
    }

    .point1_animation {
      animation: point1 1s linear 0ms infinite;
    }

    .point2_animation {
      animation: point2 1s linear 0ms infinite;
    }

    .point3_animation {
      animation: point3 1s linear 0ms infinite;
    }

    @keyframes point1 {
      0% {
        background-color: #fff;
      }

      50% {
        background-color: skyblue;
      }

      100% {
        background-color: skyblue;
      }
    }

    @keyframes point2 {
      0% {
        background-color: skyblue;
      }

      50% {
        background-color: #fff;
      }

      100% {
        background-color: skyblue;
      }
    }

    @keyframes point3 {
      0% {
        background-color: skyblue;
      }

      50% {
        background-color: skyblue;
      }

      100% {
        background-color: #fff;
      }
    }
  }
}
</style>
